"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var DS_BackTop = /** @class */ (function (_super) {
    __extends(DS_BackTop, _super);
    function DS_BackTop() {
        var _this = _super.call(this) || this;
        _this.onClick = _this.onClick.bind(_this);
        return _this;
    }
    DS_BackTop.prototype.componentDidMount = function () {
        $(window).scroll(function () {
            var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
            if (scrollTop > 20) {
                $(".dow-ds-backtop").show();
            }
            else {
                $(".dow-ds-backtop").hide();
            }
        });
    };
    DS_BackTop.prototype.onClick = function () {
        $('body,html').animate({ scrollTop: 0 }, 200);
    };
    DS_BackTop.prototype.render = function () {
        return (React.createElement("div", { className: "dow-ds-backtop" },
            React.createElement("a", { onClick: this.onClick, className: "mobile-btn icon-s-up-after" })));
    };
    return DS_BackTop;
}(React.Component));
exports.DS_BackTop = DS_BackTop;
